<div class="container-fluid mt-3">
    <div class="card">
        <h4 class="card-header">{{monthAndYear}}</h4>
        <div class="table-responsive">
            <table #table class="table footable" id="calendar">
                <thead>
                    <tr>
                        <th>Sun</th>
                        <th>Mon</th>
                        <th>Tue</th>
                        <th>Wed</th>
                        <th>Thu</th>
                        <th>Fri</th>
                        <th>Sat</th>
                    </tr>
                </thead>
                <tbody id="calendar-body">
                    
                </tbody>
            </table>
        </div>

        <!-- <div class="form-inline mt-2 mb-2">
            <div class="col-1"></div>
            <button class="btn btn-primary col-sm-4" id="previous" (click)="previous()">Prev</button>
            <div class="col-2"></div>
            <button class="btn btn-primary col-sm-4" id="next" (click)="next()">Next</button>
            <div class="col-1"></div>
        </div>
        <br />
        <form  [formGroup]="" class="form-inline">
            <label class="mr-2 ml-2" for="month">Jump To: </label>
            <select #month class="form-control col-sm-4" name="month" id="month" (change)="changeMonth(month.value)">
                <option *ngFor="let month of months">{{month}}</option>
            </select>


            <label for="year"></label>
            <select #year class="form-control col-sm-4" name="year" id="year" (change)="changeYear(year.value)">
                <option *ngFor="let item of createRange(10); let i = index" [value]="2020 + i">{{2020 + i}}</option>
            </select>
        </form> -->
    </div>
</div>